import { Card, CardContent } from '@/components/ui/card';

const highlights = [
  {
    stat: '4,500+',
    label: 'Practice Questions',
    desc: 'Covering all SAT Math and Reading & Writing topics'
  },
  {
    stat: '9',
    label: 'Full-Length Adaptive Tests',
    desc: 'Adaptive tests that mirror the official Digital SAT format'
  },
  {
    stat: '4 Weeks',
    label: 'Personalized Plan',
    desc: 'A study plan that evolves based on your performance'
  }
];

const testimonials = [
  {
    name: 'Grace R.',
    grade: 'Junior',
    scoreGain: '+160 points',
    quote: 'Practice4SAT has made SAT prep so much more manageable. The diagnostic test pinpointed exactly where I needed to focus, and scoring 1370 on my first practice test was incredibly motivating. I love how the platform keeps practice challenging without being overwhelming, and the variety of questions keeps me engaged. It\'s a tool that truly makes steady progress feel achievable.'
  },
  {
    name: 'Stephanie C.',
    grade: 'Senior',
    scoreGain: '+180 points',
    quote: 'Practice4SAT is clear, easy to use, and very effective. The diagnostic test helped me quickly see where I needed to improve, and the practice tests feel realistic and well structured. I really like the detailed explanations because they actually help you learn from your mistakes. Overall, it\'s a great resource for building confidence and improving your SAT scores.'
  },
  {
    name: 'Victor L.',
    grade: 'Senior',
    scoreGain: '+150 points',
    quote: 'I like how Practice4SAT keeps things simple and focused. The diagnostic test helped me understand my level right away, and the practice test I took felt very close to what I\'d expect on the real SAT. What stood out to me most was how the explanations break things down in a way that actually clicks. It\'s been a useful tool for practicing smarter, not just doing random questions.'
  }
];

const avatarColors = ['#667eea', '#10b981', '#f59e0b'];

export default function TestimonialsSection() {
  return (
    <>
    <section style={{ padding: '1.5rem 0', background: '#f8f9fa' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 2rem' }}>
        {/* Everything You Need to Prepare */}
        <h2 className="color-text" style={{ fontSize: '1.5rem', fontWeight: '600', textAlign: 'center', marginBottom: '0.5rem' }}>
          Everything You Need to Prepare
        </h2>
        <p className="regular-text" style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 1.5rem', color: '#666' }}>
          A structured, data-driven approach to SAT preparation
        </p>
        <div className="testimonials-grid">
          {highlights.map((item) => (
            <Card key={item.label} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <div style={{ fontSize: '2.5rem', fontWeight: '700', color: '#6366f1', marginBottom: '0.5rem' }}>
                  {item.stat}
                </div>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#111827', marginBottom: '0.5rem' }}>
                  {item.label}
                </h3>
                <p style={{ color: '#6b7280', lineHeight: '1.5', fontSize: '0.95rem', margin: 0 }}>
                  {item.desc}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>

    <section style={{ padding: '1.5rem 0', background: '#ffffff' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 2rem' }}>
        {/* What Our Students Say */}
        <h2 className="color-text" style={{ fontSize: '1.5rem', fontWeight: '600', textAlign: 'center', marginBottom: '0.5rem' }}>
          What Our Students Say
        </h2>
        <p className="regular-text" style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 1.5rem', color: '#666' }}>
          Real feedback from students who improved their SAT scores
        </p>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, idx) => (
            <Card key={testimonial.name} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: '0.25rem', marginBottom: '1rem' }}>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span key={`star-${star}`} style={{ color: '#fbbf24', fontSize: '1.25rem' }}>&#9733;</span>
                  ))}
                </div>
                
                <div style={{ flex: 1, marginBottom: '1rem', position: 'relative' }}>
                  <span style={{ 
                    position: 'absolute', 
                    left: 0, 
                    top: '-0.5rem', 
                    fontSize: '3rem', 
                    color: '#e5e7eb',
                    fontFamily: 'Georgia, serif',
                    lineHeight: 1
                  }}>"</span>
                  <p style={{ 
                    color: '#374151', 
                    lineHeight: '1.6', 
                    fontSize: '0.95rem',
                    margin: 0,
                    paddingLeft: '2rem',
                    paddingRight: '1rem'
                  }}>
                    {testimonial.quote}
                  </p>
                </div>
                
                <div style={{ 
                  borderTop: '1px solid #e5e7eb', 
                  paddingTop: '1rem',
                  marginTop: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: avatarColors[idx],
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    flexShrink: 0
                  }}>
                    {testimonial.name[0]}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ 
                      fontWeight: '600', 
                      color: '#111827',
                      fontSize: '1rem',
                      margin: 0,
                      lineHeight: 1.3
                    }} data-testid={`testimonial-name-${idx}`}>
                      {testimonial.name}
                    </p>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      marginTop: '0.25rem',
                      flexWrap: 'wrap'
                    }}>
                      <span style={{
                        color: '#6b7280',
                        fontSize: '0.8125rem',
                        fontWeight: 500
                      }} data-testid={`testimonial-grade-${idx}`}>
                        {testimonial.grade}
                      </span>
                      <span aria-hidden="true" style={{
                        width: '3px',
                        height: '3px',
                        borderRadius: '50%',
                        background: '#d1d5db'
                      }} />
                      <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '2px 8px',
                        borderRadius: '999px',
                        background: '#ecfdf5',
                        color: '#047857',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        letterSpacing: '0.01em',
                        border: '1px solid #d1fae5'
                      }} data-testid={`testimonial-score-gain-${idx}`}>
                        {testimonial.scoreGain}
                      </span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
    </>
  );
}
